var _linearGradient, _path, _path2, _path3, _path4, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1__IALWhfjB37gY_gr1",
    x1: 39.328,
    x2: 8.672,
    y1: 8.672,
    y2: 39.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60affe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#6ab4fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197,
    stopColor: "#97cbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    stopColor: "#bddeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#daecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#eef7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#fbfdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1__IALWhfjB37gY_gr1)",
    d: "M36.5,40.5h-25c-2.209,0-4-1.791-4-4v-25c0-2.209,1.791-4,4-4h25c2.209,0,4,1.791,4,4v25 C40.5,38.709,38.709,40.5,36.5,40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2e9bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M40.5,31.5v5c0,2.209-1.791,4-4,4h-25c-2.209,0-4-1.791-4-4V26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2e9bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M7.5,18.064V11.5c0-2.209,1.791-4,4-4h25c2.209,0,4,1.791,4,4v11.33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e9bfe",
    d: "M34.257,34H27.82L13.829,14h6.437L34.257,34z M28.587,32.304h2.563L19.499,15.696h-2.563L28.587,32.304z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2e9bfe",
    points: "15.866,34 23.069,25.656 22.127,24.407 13.823,34"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2e9bfe",
    points: "24.45,21.721 25.355,23.01 33.136,14 31.136,14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1942ad47976116fdc6aae783a280522f.svg";
export { ForwardRef as ReactComponent };